module.exports = __webpack_public_path__ + "media/packs/images/partners/partner-logo9-adfa53e233c21698aac56c83f4f2b5d4.jpg";